import { render } from "./EditingSectionMedia.vue?vue&type=template&id=20c38c56&scoped=true"
import script from "./EditingSectionMedia.vue?vue&type=script&lang=js"
export * from "./EditingSectionMedia.vue?vue&type=script&lang=js"

import "./EditingSectionMedia.vue?vue&type=style&index=0&id=20c38c56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20c38c56"

export default script